import * as React from 'react'

import { JASON_ARROW, KEN_ARROW, RECOMMENDATIONS_TABLE } from '../asset_constants'

const PersonalizedActivitySequencesSlide = ({ slideGroupClassName, }) => (
  <section className={`slide ${slideGroupClassName} personalized-activity-sequences-slide`} key="personalized-activity-sequences-slide">
    <h1>Diagnostics generate personalized learning plans for each student</h1>
    <div className="flex-wrapper">
      <div className="img-wrapper">
        <img
          alt="Screenshot of Recommendations table from My Diagnostics report, indicating recommended skill practice for students in the following areas: Plural and Possessive Nouns, Capitalization, and Subject-Verb Agreement. The example student Ken Liu has all three skills in the table recommended, Tahereh Mafi has just the first two, and Jason Nicks has just Capitalization."
          src={RECOMMENDATIONS_TABLE}
        />
      </div>
      <div className="text">
        <p>Once students have completed a diagnostic, you can view a variety of reports to identify student and class-wide learning gaps.</p>
        <p>Quill generates a <b>personalized learning plan</b> for students based on where they need the most help.</p>
        <p>Each <b>recommended skill</b> is linked to an activity pack you can assign to your students.</p>
        <p className="highlight-box ken">
          Ken would benefit from practicing all three skills.
          <img alt="" className="arrow" src={KEN_ARROW} />
        </p>
        <p className="highlight-box jason">
          Jason would benefit from practice with just Capitalization
          <img alt="" className="arrow" src={JASON_ARROW} />
        </p>
      </div>
    </div>
  </section>
)

export default PersonalizedActivitySequencesSlide
